import { useEffect } from 'react';

interface AnimationConfig {
    triggerSelector: string;
    triggerHook?: number;
    offsetRatio?: number;
    maxOffset?: number;
    duration?: number;
    onEnter: () => void;
}

export function useScrollAnimation(config: AnimationConfig) {
    // 默认配置
    const defaultConfig = {
        triggerHook: 1,
        offsetRatio: 0.6,
        maxOffset: 600,
        duration: 500,
        ...config,
    };

    useEffect(() => {
        if (typeof window === 'undefined') return;

        let scene: any = null;

        const clearScene = () => {
            if (scene) {
                window.AniContainer.removeScene(scene);
                scene = null;
            }
        };
        const createScene = () => {
            clearScene();
            const clientH = (window.innerHeight || 0) * defaultConfig.offsetRatio!;
            const offset = Math.min(clientH, defaultConfig.maxOffset!);

            scene = window.AniContainer.create({
                triggerElement: defaultConfig.triggerSelector,
                triggerHook: defaultConfig.triggerHook,
                offset,
                duration: defaultConfig.duration,
                onEnter: defaultConfig.onEnter,
            });
        };

        createScene();
        return () => {
            clearScene();
        };
    }, [defaultConfig]);

    return null;
}
